// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"SwitchButton_switchContainer__1Utrq","slider":"SwitchButton_slider__1JfvY","tab":"SwitchButton_tab__2u-2D","active":"SwitchButton_active__88_Sw"};